import { create, StateCreator, StoreMutatorIdentifier } from 'zustand';
import { devtools, persist, PersistStorage } from 'zustand/middleware';

import { LoggerConfig } from '@configs';

interface CreateStoreOptions {
	name: string;
	storage?: PersistStorage<unknown>;
}

export class StoreHelper {
	static createStore = <T, Mos extends [StoreMutatorIdentifier, unknown][] = []>(
		innerStore: StateCreator<T, [['zustand/devtools', never]], Mos>,
		options: CreateStoreOptions
	) =>
		create<T>()(
			devtools(
				options?.storage
					? persist((set, get, api) => innerStore(set, get, api), {
							name: options.name,
							storage: options.storage,
					  })
					: (set, get, api) => innerStore(set, get, api),
				{
					enabled: LoggerConfig.debug,
					name: options.name,
				}
			)
		);
}
